export default "__VITE_ASSET__deb46b15__"